<template>
    <div>
        <b-container fluid class="main_layer py-2">
            <b-container>
                <b-row>
                    <b-col>
                        <p class="fs-40 fw-600 white-color mb-2">Произошла ошибка при аутентификации.</p>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>
        <b-container class="py-4">
            <b-row>
                <b-col>
                    <div class="error">
                        <p class="fs-22 fw-600 grey-color">Возможные причины ошибки:</p>
                        <ul class="error-list">
                            <li class="fs-18 grey-color fw-400 my-2">— У вас не установлено и не настроено программное обеспечение "КриптоПро CSP" версии 4.0 или выше</li>
                            <li class="fs-18 grey-color fw-400 my-2">— Сертификат ключа проверки электронной подписи выдан Удостоверяющим центром Федерального казначейства.</li>
                            <li class="fs-18 grey-color fw-400 my-2">— Срок действия сертификата истек.</li>
                            <li class="fs-18 grey-color fw-400 my-2">— Сертификат ключа проверки электронной подписи находится в списке отозванных сертификатов.</li>
                            <li class="fs-18 grey-color fw-400 my-2">— Вы нажали "отмена" при выборе сертификата.</li>
                        </ul>

                        <p class="fs-22 fw-600 grey-color">Если в случае выполнения всех указанных условий ошибка повторяется, просьба обратиться в службу поддержки</p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    name: 'Error',
    metaInfo() {
        return {
            title: 'Ошибка при аутентификации'
        };
    },
};
</script>

<style scoped>
.block_head-text {
    font-size: 32px;
    color: var(--grey-color);
    font-weight: 600;
    line-height: 48px;
    margin: 33px 0;
}
.error-list {
    list-style-type: none;
}
.main_layer {
    background-image: url('/images/purchases_head.svg');
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    min-height: 100px;
}
</style>
